import { render } from "./WwtpList.vue?vue&type=template&id=13fe584a&scoped=true"
import script from "./WwtpList.vue?vue&type=script&lang=js"
export * from "./WwtpList.vue?vue&type=script&lang=js"

import "./WwtpList.vue?vue&type=style&index=0&id=13fe584a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fe584a"]])

export default __exports__